import style from './Loading.module.css';

export default function Loading() {
    return (
        <div className={style.container}>
            <img src="/assets/img/logo3.gif" alt="Загрузка" className={style.gif} />
        </div>
    )
}
